module.exports = __webpack_public_path__ + "img/logo_symbol.2cd3e439.svg";